import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import ButtonToBottomSheet from "./ButtonToBottomSheet";

function RatingButton({ rating = 0, onPress }) {
  const ratingLabel =
    rating === 0 ? "" : rating <= 2 ? "Toss" : rating === 3 ? "Solid" : "Crave";

  return (
    <ButtonToBottomSheet
      icon="star-outline"
      label="Rating"
      onPress={onPress}
      rightContent={
        <View style={styles.ratingButtonRight}>
          <View style={styles.ratingStarsRow}>
            {[1, 2, 3, 4, 5].map((n) => (
              <Ionicons
                key={n}
                name={n <= rating ? "star" : "star-outline"}
                size={18}
                color="#8B4513"
                style={{ opacity: n <= rating ? 1 : 0.5 }}
              />
            ))}
          </View>
          {ratingLabel ? (
            <Text style={styles.ratingCraveLabel}>{ratingLabel}</Text>
          ) : null}
        </View>
      }
    />
  );
}

const styles = StyleSheet.create({
  ratingButtonRight: {
    alignItems: "flex-end",
  },
  ratingStarsRow: {
    flexDirection: "row",
    gap: 2,
  },
  ratingCraveLabel: {
    fontSize: 12,
    color: "#6b7280",
    marginTop: 4,
  },
});

export default RatingButton;
